import React from 'react'
import Parallax from 'react-rellax'

import BlockContent from '../shared/blockContent'
import Image from '../image/image'

import './introBlock.css'

const IntroBlock = ({ data }) => {
  return (
    <section className="introBlock">
      {data.title && (
        <div className="heading">
          <h2>{data.title}</h2>
        </div>
      )}
      <div className="content">
        <div className="text">
          <BlockContent input={data.text}></BlockContent>
        </div>
        <div className="images">
          {data.images.map((image, index) => (
            <Parallax key={`image-${index}`} speed={1 * index} className="image">
              <Image file={image.image} alt={image.alt} />
            </Parallax>
          ))}
        </div>
      </div>
    </section>
  )
}

export default IntroBlock
